/* Mr Mattress "Our track record" page. Fade in on scroll, sticky "Choose your mattress" button, tap to play videos,
   and removal of the shared old FAQ block from the footer group on this page only.
   No libraries. If this file never loads, nothing is hidden and every link still works. */
(function () {
  'use strict';
  var d = document, root = d.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var hasIO = 'IntersectionObserver' in window;

  // The sitewide footer group carries "What Foam Mattress People Need to Know" with old claims. Not wanted here.
  try {
    d.querySelectorAll('[id$="__section_6gRfyL"]').forEach(function (e) { e.parentNode && e.parentNode.removeChild(e); });
  } catch (e) {}

  // Reveal on scroll. Anything already in view is marked in before the hidden state is switched on, so nothing flashes.
  var rv = [].slice.call(d.querySelectorAll('.tr-rv'));
  if (rv.length) {
    if (!hasIO || reduce) {
      rv.forEach(function (e) { e.classList.add('is-in'); });
    } else {
      var vh = window.innerHeight || 800;
      rv.forEach(function (e) { var r = e.getBoundingClientRect(); if (r.top < vh * 0.92 && r.bottom > 0) e.classList.add('is-in'); });
      root.classList.add('tr-js');
      var io = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } });
      }, { rootMargin: '0px 0px -8% 0px', threshold: 0.06 });
      rv.forEach(function (e) { if (!e.classList.contains('is-in')) io.observe(e); });
    }
  }

  // Sticky button: visible everywhere except while the product tiles or a main button row are on screen.
  var sticky = d.querySelector('[data-tr-sticky]');
  if (sticky && hasIO) {
    var live = {}, n = 0;
    var update = function () { sticky.classList.toggle('is-off', Object.keys(live).some(function (k) { return live[k]; })); };
    var watch = function (els, threshold) {
      var o = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) { live[en.target.__trid] = en.isIntersecting; });
        update();
      }, { threshold: threshold });
      els.forEach(function (el) { el.__trid = n++; live[el.__trid] = false; o.observe(el); });
    };
    watch([].slice.call(d.querySelectorAll('.mm-showcase')), 0.04);
    watch([].slice.call(d.querySelectorAll('[data-tr-hide-sticky]')), 0.6);
  }

  // Smooth scroll to the tiles (respect reduced motion).
  d.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[href="#choose"]');
    if (!a) return;
    var t = d.getElementById('choose');
    if (!t) return;
    ev.preventDefault();
    t.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
    if (history.replaceState) history.replaceState(null, '', '#choose');
  });

  // Tap a broadcast thumbnail to play it in place. Without JS the link opens the video on YouTube.
  d.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('a[data-yt]');
    if (!a) return;
    ev.preventDefault();
    var f = d.createElement('iframe');
    f.src = 'https://www.youtube.com/embed/' + a.getAttribute('data-yt') + '?autoplay=1&rel=0';
    f.title = a.getAttribute('data-title') || 'Video';
    f.allow = 'accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share';
    f.setAttribute('allowfullscreen', '');
    var box = a.parentNode;
    box.replaceChild(f, a);
  });
})();
